export const GeometricMark = ({ size = 36, color = "#A9842F", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Eight-pointed Islamic star — two interlocking squares */}
    <rect x="12" y="12" width="24" height="24" stroke={color} strokeWidth="1.5" />
    <rect
      x="12"
      y="12"
      width="24"
      height="24"
      stroke={color}
      strokeWidth="1.5"
      transform="rotate(45 24 24)"
    />
    <circle cx="24" cy="24" r="5" stroke={color} strokeWidth="1.2" />
    <circle cx="24" cy="24" r="1.8" fill={color} />
  </svg>
);

export const Logo = ({ compact = false, tone = "dark" }) => {
  const light = tone === "light";
  return (
    <div data-testid="logo-786-interactive" className="flex items-center gap-3 select-none">
      <GeometricMark size={compact ? 30 : 36} color={light ? "#C8A24A" : "#A9842F"} />
      <div className="flex items-baseline gap-2">
        <span
          className={`font-heading font-semibold leading-none ${light ? "text-[#C8A24A]" : "text-[#A9842F]"}`}
          style={{ fontSize: compact ? "1.6rem" : "1.9rem" }}
        >
          786
        </span>
        <span
          className={`font-body uppercase tracking-[0.3em] text-xs font-light ${light ? "text-[#F5F0E6]" : "text-[#122A1D]"}`}
        >
          Interactive
        </span>
      </div>
    </div>
  );
};
